<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="title">
            <ConsultarAutorizacoes :status="status" :verificarOrcamento="verificarOrcamento" :consultaDetalhada='true' :prefix="updatedPrefix"
                @onDblClickAutorizacao="autorizacaoSelect" />
        </b-modal>

        <lg-form-input-finder v-if="!modalOnly" :value="computedValue" @input="updateValue" fieldDescription="descricao"
            :label="label" invalidFeedback="Autorização deve ser informada!" description="" @handleClean="handleClean"
            :error="error" :cols="cols" :disabled="disabled">
            <template #prepend>
                <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import ConsultarAutorizacoes from "@/modules/compra/autorizacao-compra/ConsultarAutorizacoes.vue"

export default {
    components: { LgFormInputFinder, ConsultarAutorizacoes },
    props: {
        verificarOrcamento: {
            type: Boolean,
            default: false
        },

        status: {
            type: Number,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        consultaDetalhada: {
            type: Boolean,
            default: false
        },
        id: String,
        prefix: {
            type: Array,
            default: () => [],
        },
        value: Object,
        cols: String,
        label: String,
        error: {
            type: Object,
            default: null,
        },
        modalOnly: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            internalValue: this.value || {},
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue
            },
            set(newValue) {
                this.internalValue = newValue
            },
        },
        updatedPrefix() {
            return [...this.prefix, "Autorização"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    methods: {
        show() {
            this.$bvModal.show(this.id)
        },
        updateValue(newValue) {
            this.computedValue = newValue
            this.$emit("input", newValue)
        },
        handleClean() {
            this.computedValue = {}
            this.$emit("input", {})
        },
        autorizacaoSelect(item) {
            this.computedValue = item
            this.$emit("input", item)
            this.$bvModal.hide(this.id)
        },
    },
}
</script>
